export default "__VITE_ASSET__Bytd5bjj__"